import ResponsivePagination from 'react-responsive-pagination';

import SvgArrow from '../Icons/Arrow';
import style from './style.module.css';

type PaginationProps = {
  totalPages: number;
  currentPage: number;
  handlePageChange: (page: number) => void;
};

export default function Pagination({ totalPages, currentPage, handlePageChange }: PaginationProps) {
  return (
    <ResponsivePagination
      className={style.pagination}
      pageItemClassName={style.pageItem}
      pageLinkClassName={style.pageLink}
      disabledItemClassName={style.pageLinkDisabled}
      activeItemClassName={style.pageLinkActive}
      total={totalPages}
      previousLabel={<SvgArrow className="rotate-180" height={18} />}
      nextLabel={<SvgArrow height={18} />}
      current={currentPage}
      onPageChange={(page) => handlePageChange(page)}
      maxWidth={4} // Limita el número de páginas mostradas a 7
    />
  );
}
